var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, makeObservable } from 'mobx';
import { Mark } from '../Mark';
import { cachedSet, sortedSet } from '../../../utils/mobx/decorators/customComputed';
export class AskingMarks {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get asking() {
        return this.parent;
    }
    get app() {
        return this.asking.app;
    }
    allMarks = observable.array();
    get answerMarks() {
        return this.allMarks.filter(mark => mark.markAnswerId === this.app.answerId);
    }
    get answerMarkNames() {
        return this.answerMarks.map(mark => mark.markName);
    }
    addMark(markName) {
        this.allMarks.unshift(new Mark({ markName, app: this.app }));
    }
    removeMark(markName) {
        this.allMarks.filter(mark => mark.markName === markName).forEach(mark => this.allMarks.remove(mark));
    }
}
__decorate([
    observable.shallow
], AskingMarks.prototype, "allMarks", void 0);
__decorate([
    sortedSet
], AskingMarks.prototype, "answerMarks", null);
__decorate([
    cachedSet
], AskingMarks.prototype, "answerMarkNames", null);
__decorate([
    action.bound
], AskingMarks.prototype, "addMark", null);
__decorate([
    action.bound
], AskingMarks.prototype, "removeMark", null);
